import { render, staticRenderFns } from "./AssetUrlBar.vue?vue&type=template&id=4579177e&"
import script from "./AssetUrlBar.vue?vue&type=script&lang=js&"
export * from "./AssetUrlBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports